import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-intelligence',
  templateUrl: './customer-intelligence.component.html',
  styleUrls: ['./customer-intelligence.component.scss'],
})
export class CustomerIntelligenceComponent {}
